function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
    const regexItems = /(?:^(items)(\[([^[]+)\]))(.*?)(?:$)/;
    const regexItemsProperties = /(?:^(items)(\[([^[]+)\]))(.*?)(?:\[([^[]+)\]$)/;
    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else if (!/properties/.test(key) && regexItems.test(key)) {
      const i = parseFloat(regexItems.exec(key)[3]);
      const k = regexItems.exec(key)[4];
      obj.items = obj.items || [];
      obj.items[i] = obj.items[i] || {};
      obj.items[i][k] = formData.get(key);
    } else if (/properties/.test(key) && regexItemsProperties.test(key)) {
      const i = parseFloat(regexItemsProperties.exec(key)[3]);
      const k = regexItemsProperties.exec(key)[4];
      obj.items = obj.items || [];
      obj.items[i] = obj.items[i] || {};
      obj.items[i][k] = obj.items[i][k] || {};
      obj.items[i][k][regexItemsProperties.exec(key)[5]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = document.body.getAttribute('data-money-format');
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.formatSkusForSearch = function(skus){
  return skus.map(sku => {
            if(sku.length < 6){
              /*
                fix of the issue when old 5-digits skus "12345" give wrong search results of 6-digits skus like "12345X"
                note: it will still return wrong 6-digits skus ending to 0 like "123450", but is solution to skus "123451" - "123459"
                the results can be filtered after fetch
              */
              sku = sku.toString().padEnd(6, '0')
            }
            return `variants.sku:${sku}\*`
          });
}

Shopify.arraySplitIntoChunksBySize = function(arr, size){
  return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size)
  );
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
    const video = this.querySelector('[id^="ModalVideo-"]');
    if (!video) return;
    this.loadContent();
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      this.querySelector('[data-content]').appendChild(content).focus();
    }
  }

}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li.slider__slide');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderDots = this.querySelector('.slider-dots');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    if(this.sliderDots) {
      Array.from(this.sliderDots.querySelectorAll('.slider-dot')).forEach(dot => {
        dot.addEventListener('click', this.onButtonClick.bind(this));
      });
    }
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;

    if(this.sliderDots) {
      Array.from(this.sliderDots.querySelectorAll('.slider-dot')).forEach(dot => {
        if(parseInt(dot.dataset.index) === this.currentPage) {
          dot.classList.add('slider-dot--active');
        } else {
          dot.classList.remove('slider-dot--active');
        }
      });
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    let slideScrollPosition;

    switch(event.currentTarget.name) {
      case 'next':
        slideScrollPosition = this.slider.scrollLeft + this.sliderLastItem.clientWidth;
        break;
      case 'previous':
        slideScrollPosition = this.slider.scrollLeft - this.sliderLastItem.clientWidth;
        break;
      case 'dot':
        slideScrollPosition = parseInt(event.currentTarget.dataset.index - 1) * this.sliderLastItem.clientWidth;
        break;
    }
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.isModal = this.closest('section.product-section')?.classList.contains('product-section-quick-modal');
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      if(!this.isModal){
        this.updateMedia();
        this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductInfo();
    }

  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = this.closest('section.product-section').querySelectorAll(`#product-form, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        // Handle both occurences of price for mobile and desktop view
        [0,1].forEach(item => {
          const id = `price-${this.dataset.section}_${item}`;
          const destination = document.getElementById(id);
          const source = html.getElementById(id);

          if (source && destination) destination.innerHTML = source.innerHTML;

          const price = document.getElementById(`price-${this.dataset.section}`);

          if (price) price.classList.remove('visibility-hidden');
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });

        (() => {
          const destinationSku = document.getElementById('sku');
          const sourceSku = html.getElementById('sku');
          if (sourceSku && destinationSku) destinationSku.innerText = sourceSku.innerText;
        })();

        (() => {
          const destinationDataItemDataLayer = this.closest('.product').querySelector('[data-item-data-layer]');
          const sourceDataItemDataLaye = html.querySelector('.product [data-item-data-layer]');
          if (sourceDataItemDataLaye && destinationDataItemDataLayer) destinationDataItemDataLayer.innerHTML = sourceDataItemDataLaye.innerHTML;
        })();

        let variantChangedEvent = new Event('variant_changed');
        variantChangedEvent.payload = JSON.parse(this.closest('.product').querySelector('[data-item-data-layer]').innerHTML);
        document.dispatchEvent(variantChangedEvent);

      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

function roundUpNearest10(num) {
  return Math.ceil(num / 10) * 10;
}
class TruncatedText extends HTMLElement {

  constructor() {
    super();
    this.btn = this.querySelector('[data-toggle]');
    this.content = this.querySelector('[data-content]');
    this.btn.addEventListener('click', this.onButtonClick.bind(this));
    this.lineCount = 3;
    this.firstMarginTop = 0;
    window.addEventListener('DOMContentLoaded', () => {
      const maximumHeight = ((this.lineCount || 1) * parseInt(window.getComputedStyle(this.content).lineHeight, 10)) + this.firstMarginTop;
      const maximumHeightWithBuffer = roundUpNearest10(maximumHeight);
      
      if (this.content.scrollHeight > maximumHeightWithBuffer) {
        this.content.classList.add('truncated-text__content--truncated');
        this.content.style.display = '-webkit-box';
        this.content.style.setProperty('--sh', `${this.content.scrollHeight + 5}px`);
        this.content.style.setProperty('--mh', `${maximumHeight + 5}px`);
     
        // Hide "show more" button if the text is not trimmed
        if(this.content.getElementsByTagName('span')[0] && (this.content.offsetHeight > this.content.getElementsByTagName('span')[0].offsetHeight)) {
            this.btn.style.display = 'none';
        }

        // this.content.style.cssText += `max-height: ${maximumHeight}px; overflow:hidden; overflow-wrap:break-word; word-wrap:break-word`;
        // const childNodes = this.content.childNodes;
        // let i = childNodes.length - 1;
        // while (i > -1) {
        //   const childNode = childNodes[i--]
        //   if (childNode.nodeType === 1) {
        //     truncateElementNode();
        //   }
        //   if (childNode.nodeType === 3) {
        //     truncateTextNode();
        //   }
        // }
      } else {
        this.btn.style.display = 'none';
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    if (this.content.hasAttribute('open')) {
      this.content.removeAttribute('open');
      this.content.setAttribute('is-closing', '');
      this.btn.innerText = this.btn.getAttribute('data-i18n-read-more');
      setTimeout(() => {
        this.content.removeAttribute('is-closing');
        this.content.removeAttribute('open');
        setTimeout(() => {
          this.content.style.display = '-webkit-box';
        }, 100);
      }, 300);
    } else {
      this.content.style.display = '';
      this.content.setAttribute('is-opening', '');
      this.content.style.setProperty('--sh', `${this.content.scrollHeight + 5}px`);
      this.btn.innerText = this.btn.getAttribute('data-i18n-read-less');
      setTimeout(() => {
        this.content.removeAttribute('is-opening');
        this.content.setAttribute('open', '');
      }, 300);
    }
  }



}

customElements.define('truncated-text', TruncatedText);

class ProductCard extends HTMLElement {

  constructor() {
    super();
    this.itemSelectedEvent = new Event('item_selected');
    this.anchors = this.querySelectorAll('a');
    this.anchors.forEach(a => a.addEventListener('click', e => {
      this.onAnchorClick(e, a);
    }))
  }

  onAnchorClick(e, el) {
    if (el.getAttribute('href').includes('/products/')) {
      e.preventDefault();
      try {
        this.itemSelectedEvent.payload = JSON.parse(this.querySelector('[data-item-data-layer]').innerHTML);
        this.itemSelectedEvent.custom_target = this.classList.contains('product-card--in-cart') ? 'cart' : false;
        document.dispatchEvent(this.itemSelectedEvent);
      } catch (error) { }
      setTimeout(() => {
        window.location.href = el.getAttribute('href');
      }, 200);
    }
  }

}

customElements.define('product-card', ProductCard);

/* close elements on swipe left/right/top/bottom */
function swipedetect(el, callback){
  
    var touchsurface = el,
    swipedir,
    startX,
    startY,
    distX,
    distY,
    threshold = 150, //required min distance traveled to be considered swipe
    restraint = 100, // maximum distance allowed at the same time in perpendicular direction
    allowedTime = 300, // maximum time allowed to travel that distance
    elapsedTime,
    startTime,
    handleswipe = callback || function(swipedir){}
  
    touchsurface.addEventListener('touchstart', function(e){
        var touchobj = e.changedTouches[0]
        swipedir = 'none'
        dist = 0
        startX = touchobj.pageX
        startY = touchobj.pageY
        startTime = new Date().getTime() // record time when finger first makes contact with surface
        //e.preventDefault()
    }, {passive: true})

  /*
    touchsurface.addEventListener('touchmove', function(e){
        //e.preventDefault() // prevent scrolling when inside DIV
    }, false)
  */
  
    touchsurface.addEventListener('touchend', function(e){
        var touchobj = e.changedTouches[0]
        distX = touchobj.pageX - startX // get horizontal dist traveled by finger while in contact with surface
        distY = touchobj.pageY - startY // get vertical dist traveled by finger while in contact with surface
        elapsedTime = new Date().getTime() - startTime // get time elapsed
        if (elapsedTime <= allowedTime){ // first condition for awipe met
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){ // 2nd condition for horizontal swipe met
                swipedir = (distX < 0)? 'left' : 'right' // if dist traveled is negative, it indicates left swipe
            }
            else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint){ // 2nd condition for vertical swipe met
                swipedir = (distY < 0)? 'up' : 'down' // if dist traveled is negative, it indicates up swipe
            }
        }
        handleswipe(swipedir)
        //e.preventDefault()
    }, false)
}

if (!Function.prototype.debounce) {
  /**
   * This method delays the execution of a function until the last occurance of e.g. an event fired within a specified period. This is useful if the function is bound to an frequently firing event, like `scroll` or `resize`.
   * @param delay the period (in milliseconds) the function get delayed for.
   */
  Function.prototype.debounce = function _debounceFunction(delay) {
      const f = this;
      delay = delay || 250;
      let t;
      return function () {
          clearTimeout(t);
          t = setTimeout(() => {
              t = null;
              f.apply(this, arguments);
          }, delay);
      };
  };
}

const footerLinkMasonryResize = function(){
  let footer_link_list_wrapper = document.querySelector('.footer__link-block-masonry .footer-link-list-wrapper');
  if(!footer_link_list_wrapper) return false;

  if(window.innerWidth >= 769){
    var hdefault = (window.innerWidth >= 1440) ? 600 : 450;
    
    var hl = 20, hr = 20; /*some margin bottom*/
    footer_link_list_wrapper.querySelectorAll('footer-link-list').forEach((fl, index) => {
      if(index % 2 == 1){
        hr += fl.offsetHeight;
      } else {
        hl += fl.offsetHeight;
      }
    });
    
    footer_link_list_wrapper.style.setProperty('max-height', Math.max(hdefault, hl, hr) + "px");
  } else {
    footer_link_list_wrapper.style.removeProperty('max-height');
  }
}

const setDimensions = function () {
  // view height https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  let vh = (window.innerHeight || document.documentElement.clientHeight) * 0.01;
  // view width
  let vw = (window.innerWidth || document.documentElement.clientWidth) * 0.01;
  // header height to be able to set content to 100% of view height minus the device and state dependent height of the header
  let hh = document.querySelector(`header.header`) ? document.querySelector(`header.header`).clientHeight : 0;
  // search-bar height to position the quick search and calculate its max-height according to available space on viewport
  // let sbh = document.querySelector('.search-bar').clientHeight;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--hh', `${hh}px`);
  // document.documentElement.style.setProperty('--sbh', `${sbh}px`);
}

setDimensions();

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function(){
    footerLinkMasonryResize();
  },3000);
});

window.addEventListener("resize", function() {
    setDimensions();
    footerLinkMasonryResize()
}.debounce());

window.addEventListener("scroll", function() {
    setDimensions();
}.debounce());

/**
 * Shopify chat inbox - the attribute 'isopen' of the chat iframe is now removed and cannot detect whether the chat is open
 * This listener is alternative till the Chat is updated with a better isopen detection
 */
var bodyStyleObserver = new MutationObserver(function(mutations){
  if(mutations[0].type == 'attributes'){
    if(document.body.style?.position == 'fixed'){
      document.body.classList.add('has-style-position-fixed');
    } else {
      document.body.classList.remove('has-style-position-fixed');
    }
  }
  
});
bodyStyleObserver.observe(document.body, { attributes : true, attributeFilter : ['style'] });

/**
 * Because of the iOS scrolling bug, we need helpers to lock the scroll for e.g. modals and overlays
 * See: https://getbootstrap.com/docs/4.0/getting-started/browsers-devices/#overflow-and-scrolling
 * See also resolution here: https://bugs.webkit.org/show_bug.cgi?id=153852#c43
 */
if (!Document.prototype.scrollLock) {
  Document.prototype.disablePageScroll = function () {
    const offsetY = window.pageYOffset;
    document.body.style.top = `${-offsetY}px`;
    document.body.setAttribute('data-disable-page-scroll', '');
  }
}
if (!Document.prototype.scrollLock) {
  Document.prototype.enablePageScroll = function () {
    const offsetY = Math.abs(parseInt(document.body.style.top || 0, 10));
    document.body.removeAttribute('data-disable-page-scroll');
    document.body.style.removeProperty('top');
    window.scrollTo(0, offsetY || 0);
  }
}